export enum ContactMethod {
  Call = 'call',
  WriteWhatsApp = 'write_whatsapp',
  WriteTelegram = 'write_telegram',
}

export type ContactMethodItem = {
  value: ContactMethod;
  title: string;
};
